import React from "react";
import { FormSectionElements, LOVValues, ProgramContainer } from "../../entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";
import SessionStorageService from "../../services/SessionStorageService";
import DataUtils from "../../utilities/DataUtils";
import { TOKEN_TYPE } from "../../entities/Constants";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  usedForFilter;
}

interface State {


}
export class DropdownComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
  }

  async componentDidMount(): Promise<void> {
    this.getDropdownList();
    let field = this.props.field;

    if (!field.Value ||this.props.field.Value === undefined) {
      this.props.field.Value = this.props.field.ListOfLOVValues[0].code;
    }
    try {
      FormValidationUtils.runJavascript(field);
    } catch (ex) {
      console.log(ex);
    }

  }

  getDropdownList = async () => {
    let field = this.props.field;
    let programContainer: ProgramContainer = field.parent.parent.parent;

    if (field.LovAPI) {
      try {
        const accessToken = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        let url = programContainer.APIBasePath + "/" + field.LovAPI;
      
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          }
        },);

        field.ListOfLOVValues = [];
        if (Array.isArray(response.data)) {
          response.data.forEach(item => {
            let lov = new LOVValues();
            lov.code = item;
            lov.description = item;
            lov.parent = field;
            field.ListOfLOVValues.push(lov);
          })
        }
        DataUtils.assignFormValue(programContainer);
      } catch (ex) {
        console.log(ex);
      }
    }
  }

  getProgramContainer=async ()=>{
    const field =this.props.field;
    let programContainer = field.parent.parent.parent as ProgramContainer;
  
    const accessToken = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
    let url = programContainer.APIBasePath + "/" + programContainer.GetAPI;
    if (field.Value) {
      url = url + "/" + field.Value
    }
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      }
    });

    return response.data;

  }
  
  onDropdownChangeOnDialog = async (e) => {
    let val = null;
    let field = this.props.field;

    if (e.value) {
      val = e.value;
    } else {
      let elem = e.originalEvent ? e.originalEvent.target : e.target;
      val = elem.value;
    }

    field.Value = val;

    try {
      FormValidationUtils.validateDropdown(field)
      FormValidationUtils.runJavascript(field);
    } catch (ex) {
      console.log(ex)
    }
    
    let programContainer=field.parent.parent.parent;

    programContainer.Entity=await this.getProgramContainer()
     DataUtils.assignFormValue(programContainer);
    this.props.callbackElement(programContainer);
  }


  render() {
    let field = this.props.field;
    if (!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;
    let style


    const lovOptions = field.ListOfLOVValues;

    if (field.AddEmptyItemToList == 'Y' && lovOptions.find(p => p.Sequence == 0) == null) {
      let item = new LOVValues();
      item.parent = field;
      item.Sequence = 0;
      lovOptions.unshift(item);
    }

    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype + '_' + field.Id} id={'div_' + field.Datatype + '_' + field.Id}>

          <div key={'fdIpt_div_' + field.Id} className="ontario-form-group">
            <label className="ontario-label">
              {!this.props.usedForFilter ? <div key={'fdLbl_dropdown_label_' + field.Id} id={'fdLbl_dropdown_label_' + field.Id}>
                {labelControlArray}
              </div> : null}
            </label>

            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />


            <select
              className={'ontario-input ontario-dropdown'}
              id={field.LoadBindName}
              key={'fdIpt_ontario-dropdown' + field.Id}
              style={style}
              value={this.props.field.Value || (lovOptions.length > 0 ? lovOptions[0].code : '')}
              onChange={this.onDropdownChangeOnDialog}>
              {lovOptions.map((option, index) => (
                <option
                  key={option.code} // Assuming 'code' is the unique identifier for each option
                  value={option.code} // Assuming 'code' is the value for each option
                >
                  {this.props.isEng ? option.description : option.FRADescription}
                </option>
              ))}
            </select>
          </div>

        </div>);
    } else {
      let descList = lovOptions.filter(p => p.code == field.Value);
      controlArray.push(
        <div className='pdf-two-column'>
          <div>{title}</div>
          <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >
            {descList != null && descList.length > 0 ? descList[0].description : null}
          </div>
        </div>
      )
    }

    return controlArray;
  }
}